(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3459],{

/***/ 36429:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/login",
      function () {
        return __webpack_require__(64984);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 51121:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styles_modules_Input_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47909);
/* harmony import */ var styles_modules_Input_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(styles_modules_Input_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Svg_Eye__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17485);





var Input = function(param) {
    var value = param.value, type = param.type, onFocus = param.onFocus, onBlur = param.onBlur, onChange = param.onChange, onKeyUp = param.onKeyUp, placeholder = param.placeholder, label = param.label, name = param.name, disabled = param.disabled, color = param.color, error = param.error, register = param.register, _classes = param.classes, classes = _classes === void 0 ? [] : _classes, labelAbove = param.labelAbove;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(type || "text"), inputType = ref[0], setInputType = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), active = ref1[0], setActive = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var ref;
        var inputValue = (ref = document.getElementById(name)) === null || ref === void 0 ? void 0 : ref.value;
        if (value && value.trim() !== "" || inputValue && inputValue.trim() !== "") setActive(true);
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: [
            (styles_modules_Input_module_scss__WEBPACK_IMPORTED_MODULE_3___default().inputWrapper),
            (styles_modules_Input_module_scss__WEBPACK_IMPORTED_MODULE_3___default())["inputWrapper".concat(color)],
            error ? (styles_modules_Input_module_scss__WEBPACK_IMPORTED_MODULE_3___default().inputWrapperError) : null,
            labelAbove ? (styles_modules_Input_module_scss__WEBPACK_IMPORTED_MODULE_3___default().hasLabelAbove) : "", 
        ].join(" "),
        children: [
            labelAbove && label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                className: (styles_modules_Input_module_scss__WEBPACK_IMPORTED_MODULE_3___default().labelAbove),
                htmlFor: name,
                children: label
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                id: name,
                name: name,
                type: inputType,
                className: [
                    (styles_modules_Input_module_scss__WEBPACK_IMPORTED_MODULE_3___default().input),
                    active ? (styles_modules_Input_module_scss__WEBPACK_IMPORTED_MODULE_3___default().inputActive) : null, 
                ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(classes), [
                    error ? (styles_modules_Input_module_scss__WEBPACK_IMPORTED_MODULE_3___default().error) : "",
                    labelAbove ? (styles_modules_Input_module_scss__WEBPACK_IMPORTED_MODULE_3___default().hasLabelAbove) : "", 
                ]).join(" "),
                onFocus: function(event) {
                    setActive(true);
                    onFocus ? onFocus(event) : null;
                },
                onBlur: function(event) {
                    event.target.value ? null : setActive(false);
                    onBlur ? onBlur(event) : null;
                },
                onChange: function(event) {
                    setActive(true);
                    onChange ? onChange(event) : null;
                },
                onKeyUp: onKeyUp ? function(param) {
                    var value = param.target.value;
                    return onKeyUp(name, value.trim());
                } : null,
                ref: register,
                placeholder: placeholder,
                defaultValue: value,
                disabled: disabled
            }),
            !labelAbove && label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                htmlFor: name,
                children: label
            }),
            type === "password" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (styles_modules_Input_module_scss__WEBPACK_IMPORTED_MODULE_3___default().password),
                onClick: function() {
                    return inputType === "password" ? setInputType("text") : setInputType("password");
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg_Eye__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {})
            }),
            (error === null || error === void 0 ? void 0 : error.message) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: (styles_modules_Input_module_scss__WEBPACK_IMPORTED_MODULE_3___default().error),
                children: error.message
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Input);


/***/ }),

/***/ 17485:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Eye; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

function Eye(props) {
    var _fill;
    var fill = (_fill = props.fill) !== null && _fill !== void 0 ? _fill : "#212121";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 1418 916",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: fill,
                d: "M708.531 676.277c120.483 0 218.154-97.671 218.154-218.154 0-120.483-97.671-218.154-218.154-218.154-120.483 0-218.154 97.671-218.154 218.154 0 120.483 97.671 218.154 218.154 218.154z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: fill,
                d: "M1395.29 397.695C1227.6 195.057 973.767 0 708.516 0 443.214 0 189.318 195.193 21.7404 397.695c-28.9872 35.013-28.9872 85.843 0 120.857 42.131 50.911 130.4556 149.19 248.4226 235.061 297.096 216.277 578.956 216.755 876.707 0 117.97-85.871 206.29-184.15 248.42-235.061 28.9-34.946 29.05-85.729 0-120.857zM708.516 152.708c168.415 0 305.414 137 305.414 305.415 0 168.415-136.999 305.416-305.414 305.416S403.101 626.538 403.101 458.123s137-305.415 305.415-305.415z"
            })
        ]
    });
}


/***/ }),

/***/ 23775:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styles_modules_Typo_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61176);
/* harmony import */ var styles_modules_Typo_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styles_modules_Typo_module_scss__WEBPACK_IMPORTED_MODULE_1__);




var Typo = function(props) {
    var variant = props.variant, Tag = props.Tag, color = props.color, className = props.className, children = props.children, font = props.font;
    if (!Tag) {
        switch(variant){
            case "h1":
            case "h2":
            case "h3":
            case "h4":
            case "h5":
            case "h6":
            case "blockquote":
                Tag = variant;
                break;
            default:
                Tag = "p";
        }
    }
    if (!variant) variant = "body";
    var classes = [
        (styles_modules_Typo_module_scss__WEBPACK_IMPORTED_MODULE_1___default().typo),
        variant ? (styles_modules_Typo_module_scss__WEBPACK_IMPORTED_MODULE_1___default())["typo--".concat(variant)] : null,
        color ? (styles_modules_Typo_module_scss__WEBPACK_IMPORTED_MODULE_1___default())["typo--".concat(color)] : null,
        font ? (styles_modules_Typo_module_scss__WEBPACK_IMPORTED_MODULE_1___default())["typo--".concat(font)] : null,
        className ? className : null, 
    ].filter(Boolean).join(" ");
    var modifiedProps = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props), {
        className: classes
    });
    // Remove props so they don't appear in DOM
    delete modifiedProps.variant;
    delete modifiedProps.Tag;
    delete modifiedProps.font;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tag, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, modifiedProps), {
        children: children
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Typo);


/***/ }),

/***/ 71642:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LoginLayout; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styles_modules_Login_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82844);
/* harmony import */ var styles_modules_Login_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styles_modules_Login_module_scss__WEBPACK_IMPORTED_MODULE_1__);


function LoginLayout(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (styles_modules_Login_module_scss__WEBPACK_IMPORTED_MODULE_1___default().pageLogin),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: [
                "container",
                (styles_modules_Login_module_scss__WEBPACK_IMPORTED_MODULE_1___default().container)
            ].join(" "),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (styles_modules_Login_module_scss__WEBPACK_IMPORTED_MODULE_1___default().body),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (styles_modules_Login_module_scss__WEBPACK_IMPORTED_MODULE_1___default().bodyWrapper),
                    style: {
                        width: props.forceWidth ? "100%" : undefined,
                        maxWidth: props.forceWidth ? "none" : undefined
                    },
                    children: props.children
                })
            })
        })
    });
}


/***/ }),

/***/ 64984:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(10092);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(39666);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42283);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25617);
/* harmony import */ var components_Button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(44217);
/* harmony import */ var components_Input__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(51121);
/* harmony import */ var data_globalConstants__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(23208);
/* harmony import */ var lang_en_json__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(64798);
/* harmony import */ var layouts_LoginLayout__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(71642);
/* harmony import */ var store_auth__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(32505);
/* harmony import */ var styles_modules_Login_module_scss__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(82844);
/* harmony import */ var styles_modules_Login_module_scss__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(styles_modules_Login_module_scss__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var utils_parse_jwt__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(78862);
/* harmony import */ var next_seo_config__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(5056);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(2962);
/* harmony import */ var store__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(23261);
/* harmony import */ var components_Typo__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(23775);























var Login = function() {
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useDispatch */ .I0)();
    var ref = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useSelector */ .v9)(store_auth__WEBPACK_IMPORTED_MODULE_10__/* .authSelector */ .aF), isAuthenticated = ref.isAuthenticated, token = ref.token, error = ref.error;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var ref1 = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_4__/* .useForm */ .cI)(), register = ref1.register, handleSubmit = ref1.handleSubmit, errors = ref1.errors;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), visibleError = ref2[0], setVisibleError = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), loading = ref3[0], setLoading = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(""), errorMessage = ref4[0], setErrorMessage = ref4[1];
    var showErrorMessage = function() {
        console.log(error);
        setVisibleError(true);
        setLoading(false);
    };
    var onSubmit = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(data) {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
                setLoading(true);
                setErrorMessage("");
                dispatch((0,store_auth__WEBPACK_IMPORTED_MODULE_10__/* .authenticate */ .YR)(data));
                if (error) {
                    setErrorMessage(error);
                    return [
                        2,
                        showErrorMessage()
                    ];
                }
                return [
                    2
                ];
            });
        });
        return function onSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if (isAuthenticated) {
            var ref = (0,utils_parse_jwt__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(token), company = ref.company, isJournalist = ref.isJournalist;
            if (isJournalist) {
                _sentry_nextjs__WEBPACK_IMPORTED_MODULE_18__/* .setUser */ .av({
                    journalist: company
                });
            } else {
                _sentry_nextjs__WEBPACK_IMPORTED_MODULE_18__/* .setUser */ .av({
                    company: company
                });
            }
            var redirect = router.query.redirect;
            if (redirect) {
                router.push("".concat(redirect)).then(function() {
                    return window.scrollTo(0, 0);
                });
            } else {
                router.push("".concat(company)).then(function() {
                    return window.scrollTo(0, 0);
                });
            }
        }
        if (error) {
            showErrorMessage();
        }
        setErrorMessage(error);
    }, [
        isAuthenticated,
        error
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_13__/* .NextSeo */ .PB, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)({}, next_seo_config__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z), {
                titleTemplate: "Login | %s"
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(layouts_LoginLayout__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
                    onSubmit: handleSubmit(onSubmit),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("header", {
                            className: (styles_modules_Login_module_scss__WEBPACK_IMPORTED_MODULE_21___default().header),
                            children: [
                                errorMessage && visibleError && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (styles_modules_Login_module_scss__WEBPACK_IMPORTED_MODULE_21___default().errorBox),
                                    children: [
                                        "The email or password is not correct.",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                        "Did you",
                                        " ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                            href: "/forgot-password",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                children: "forget your password?"
                                            })
                                        })
                                    ]
                                }),
                                errorMessage === "Deactivated" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (styles_modules_Login_module_scss__WEBPACK_IMPORTED_MODULE_21___default().errorBox),
                                    children: [
                                        "Your account has been deactivated, please contact",
                                        " ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            href: "mailto:support@newspage.co.uk",
                                            children: "support@newspage.co.uk"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Typo__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                    Tag: "h1",
                                    variant: "h1",
                                    className: "mb-l",
                                    children: "Welcome back!"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (styles_modules_Login_module_scss__WEBPACK_IMPORTED_MODULE_21___default().inputWrapper),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Input__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    name: "email",
                                    type: "email",
                                    label: "E-mail",
                                    color: "blue",
                                    error: errors["email"],
                                    register: register({
                                        required: lang_en_json__WEBPACK_IMPORTED_MODULE_8__/* .validation.required */ .Uf.C1,
                                        pattern: {
                                            value: data_globalConstants__WEBPACK_IMPORTED_MODULE_22__/* .EmailRegEx */ ._e,
                                            message: lang_en_json__WEBPACK_IMPORTED_MODULE_8__/* .validation.email */ .Uf.Do
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Input__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    type: "password",
                                    label: "Password",
                                    name: "password",
                                    color: "blue",
                                    error: errors["password"],
                                    register: register({
                                        required: lang_en_json__WEBPACK_IMPORTED_MODULE_8__/* .validation.required */ .Uf.C1
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: [
                                "mb-l",
                                (styles_modules_Login_module_scss__WEBPACK_IMPORTED_MODULE_21___default().linksWrapper)
                            ].join(" "),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (styles_modules_Login_module_scss__WEBPACK_IMPORTED_MODULE_21___default().col),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                    className: (styles_modules_Login_module_scss__WEBPACK_IMPORTED_MODULE_21___default().remember_me),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                            ref: register(),
                                            type: "checkbox",
                                            name: "remember_me"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            children: "Remember me"
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: [
                                "mb-l",
                                (styles_modules_Login_module_scss__WEBPACK_IMPORTED_MODULE_21___default().linksWrapper)
                            ].join(" "),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (styles_modules_Login_module_scss__WEBPACK_IMPORTED_MODULE_21___default().col),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                        href: "/forgot-password",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            children: "Can't log in?"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: [
                                        (styles_modules_Login_module_scss__WEBPACK_IMPORTED_MODULE_21___default().col),
                                        "textRight"
                                    ].join(" "),
                                    children: [
                                        "Not registered yet?",
                                        " ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                            href: "/register",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                children: "Join now!"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Button__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            title: "Log in",
                            theme: "primary",
                            type: "submit",
                            loading: loading
                        })
                    ]
                })
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (store__WEBPACK_IMPORTED_MODULE_14__/* .wrapper.withRedux */ .Y.withRedux(Login));


/***/ }),

/***/ 82844:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pageLogin":"Login_pageLogin__6XM1O","container":"Login_container__63_yD","body":"Login_body__Zpkpo","bodyWrapper":"Login_bodyWrapper__uxKZh","header":"Login_header__y0gdP","errorBox":"Login_errorBox__8pq4X","successBox":"Login_successBox___DLRj","title":"Login_title__4kHMs","titleSmaller":"Login_titleSmaller__I3UFq","inputWrapper":"Login_inputWrapper__qvNz1","copy":"Login_copy__lv5oh","linksWrapper":"Login_linksWrapper__raBCV","col":"Login_col__krdMt","remember_me":"Login_remember_me__yJ8IV","highlighted":"Login_highlighted__R_Til"};

/***/ }),

/***/ 61176:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"typo--serif":"Typo_typo--serif__ahG_k","typo--h1":"Typo_typo--h1__k9d1d","typo--h2":"Typo_typo--h2__ERFQP","typo--h3":"Typo_typo--h3__96TzI","typo--perex":"Typo_typo--perex__jtAL0","typo--body":"Typo_typo--body__N8tZg","typo--small":"Typo_typo--small__IMpLY","typo--caption":"Typo_typo--caption__BQ_Ci","typo--special":"Typo_typo--special__PCh7S","typo--quote":"Typo_typo--quote__kbLSb","typo--quote-author":"Typo_typo--quote-author__gGzSj"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2283,9774,2888,179], function() { return __webpack_exec__(36429); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);